import React, { useMemo } from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';

// Components
import CountryIcon from './CountryIcon';
import CountryFlag from './CountryFlag';

import { getSelectedOption } from './CountrySelectWithIcon';

const DIVIDER_STYLE = {
  fontSize: '1px',
  backgroundColor: 'currentColor',
  color: 'inherit',
  paddingBottom: '5px',
  marginBottom: '5px',
  borderBottom: '1px solid #ccc',
};

const CountryOption = ({ children, data, ...props }) => {
  const { key, value, divider } = data;
  let options = props?.options || props.selectProps?.options;
  const unicodeFlags = props.selectProps?.unicodeFlags || false;

  const selectedOption = useMemo(() => {
    return getSelectedOption(options, value);
  }, [options, value]);

  return (
    <components.Option
      key={divider ? '|' : key || 'ZZ'}
      value={divider ? '|' : value || 'ZZ'}
      disabled={divider ? true : false}
      style={divider ? DIVIDER_STYLE : undefined}
      role={divider ? 'separator' : 'option'}
      {...props}
    >
      <CountryFlag
        className="mr-10"
        unicodeFlags={unicodeFlags}
        value={value}
        selectedOption={selectedOption}
        iconComponent={CountryIcon}
      />
      <span>{children}</span>
    </components.Option>
  );
};

CountryOption.propTypes = {
  children: PropTypes.string,
  data: PropTypes.object,
  options: PropTypes.array,
  selectProps: PropTypes.object,
};

export default CountryOption;
